export const tipoContratacion = [
    {
      CODIGO: "1",
      NOMBRE: "Prepago",
    },
    {
      CODIGO: "2",
      NOMBRE:
        "Pospago",
    },
  ];